/** @format */

import React from 'react';
import { useParams } from 'react-router-dom';
import { blogs } from '../data';
import { AnnotationIcon } from '@heroicons/react/solid';
import { useNavigate } from 'react-router-dom';
import { formatDescription } from './BlogPageFormatParagraph';

export function BlogPageView() {
  const { id } = useParams();
  const blogId = parseInt(id, 10);
  const blog = blogs.find((blog) => blog.id === blogId);
  const navigate = useNavigate();

  if (!blog) {
    return <div>Blog not found.</div>;
  }

  return (
    <section
      id="blog-page"
      className="h-full min-h-screen text-gray-400 bg-gray-900 body-font"
    >
      <header className="top-0 z-10 bg-gray-800 md:sticky">
        <div className="container flex flex-col flex-wrap items-center p-5 mx-auto md:flex-row">
          <div className="mb-4 font-medium text-white title-font md:mb-0">
            <div
              className="ml-3 text-xl cursor-pointer"
              onClick={() => navigate(`/`)}
            >
              Mohamed Daadaa
            </div>
          </div>
        </div>
      </header>
      <div className="container px-5 py-10 mx-auto text-center">
        <AnnotationIcon className="inline-block w-10 mb-4" />
        <h1 className="mb-12 text-3xl font-medium text-white sm:text-4xl title-font">
          {blog.title}
        </h1>
        <img alt={blog.title} src={blog.image} className="h-56 mx-auto" />
        <div className="w-full p-4 px-24">
          <div className="h-full p-8 bg-gray-800 rounded bg-opacity-40">
            <div className="flex justify-between">
              <span className="mb-4 font-bold text-white rounded whitespace-nowrap text-white-500">
                Section: {blog.type}
              </span>
              <span className="mb-4 font-bold text-white rounded whitespace-nowrap text-white-500">
                Date: {blog.date}
              </span>
            </div>
            <div className="flex w-full mb-3 bg-bg-gray">
              <div className="inline-flex items-center">
                <span className="flex flex-col flex-grow pl-4">
                  <span className="text-sm text-gray-500 uppercase">
                    {blog.company}
                  </span>
                </span>
              </div>
            </div>
            <p className="px-24 mb-6 text-xl font-semibold leading-relaxed tracking-normal text-justify">
              {formatDescription(blog.description)}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
